module.exports = __webpack_public_path__ + "b1458800052c8e96db8a2ea9284e7253.svg";